import {Component, OnInit, Output, EventEmitter} from '@angular/core';

import {LogService} from '../../../../services/log.service';
import {TabService} from '../../../../services/tab.service';


@Component({
	selector: 'navigate',
	templateUrl: './navigate.component.html',
	styleUrls: ['./navigate.component.scss']
})
export class NavigateComponent implements OnInit {
	constructor(
		private log: LogService,
		private tabService: TabService
	) {}


	tabs: any = {};


	ngOnInit() {
		// TODO!!! - put this back after profile settings, with volunteer application off by default
		// this.tabs = this.tabService.navTabs;

		console.log('NavigateComponent, ngOnInit');
		console.log('this.tabs');
		console.log(this.tabs);

		let tabsWithoutVolunteer = JSON.parse( JSON.stringify(this.tabService.navTabs) );

		if (
			!tabsWithoutVolunteer ||
			!tabsWithoutVolunteer.firstTabs ||
			tabsWithoutVolunteer.firstTabs.length === 0
		) {
			this.log.error('NavigateComponent, invalid tabs from tabService');
			return;
		}

		// find index of VOLUNTEER module
		let index = tabsWithoutVolunteer.firstTabs.findIndex((firstTab) => {
			// return (firstTab.name === 'VOLUNTEER');
			if (firstTab.name === 'VOLUNTEER') {
				if (
					firstTab.secondTab &&
					firstTab.secondTab.tabs &&
					firstTab.secondTab.tabs.length === 1 &&
					firstTab.secondTab.tabs[0].name === 'VOLUNTEER APPLICATION'
				) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		});

		// then remove it
		if (index !== -1) {
			tabsWithoutVolunteer.firstTabs.splice(index, 1);
		}

		this.tabs = tabsWithoutVolunteer;


	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/navigate/navigate.component.ts